var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"tableData":_vm.tableData,"tableHeadList":_vm.tableHeadList},on:{"handleDelete":_vm.handleDelete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }